import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core';
import styles from './styles';

export default withStyles(styles)(TableCell);
